import { env } from "@/config/env";
import { BILLING_ROUTES } from "@/lib/subscription-management";

type ResolveBillingHrefArgs = {
  email: string | undefined;
  isKickstarter: boolean;
  isSubscriptionActive: boolean | undefined;
  isSubscriptionManagementEnabled: boolean;
};

export function resolveBillingHref({
  email,
  isKickstarter,
  isSubscriptionActive,
  isSubscriptionManagementEnabled,
}: ResolveBillingHrefArgs): string {
  if (isKickstarter || !isSubscriptionActive) {
    return "/pricing";
  }

  if (isSubscriptionManagementEnabled) {
    return BILLING_ROUTES.overview;
  }

  return `${env.VITE_BILLING_URL}${env.VITE_STRIPE_BILLING_TOKEN}?prefilled_email=${encodeURIComponent(email ?? "")}`;
}
